export default __webpack_public_path__ + "864b62d.png";